import { IBrandConfig, IBrandTheme } from '@/interfaces/interface_branding';

const anatinConfig: IBrandConfig = {
  name: process.env.VUE_APP_COMPANY_NAME || 'Anatín Cafeterías',
  legalName: process.env.VUE_APP_COMPANY_LEGAL_NAME || 'Anatín Cafeterías, S.A.',
  logo: 'logocafeteria.png',
  email: process.env.VUE_APP_EMAIL || 'info@anatin.com',
  phone: process.env.VUE_APP_PHONE || '50761994883',
  website: process.env.VUE_APP_WEBSITE || 'https://anatin.com',
  tagline: process.env.VUE_APP_TAGLINE || 'Recarga la lonchera escolar',
  apiUrl: process.env.VUE_APP_API_URL || 'https://quepedimoscr.co',
  bankAccount: process.env.VUE_APP_BANK_ACCOUNT || '04-23-00-0030834',
};

const anatinTheme: IBrandTheme = {
  primary: '#2E7D5A',
  secondary: '#3EA272',
  accent: '#2E7D5A',
  background: '#FAFAF7',
};

export const activeBrand = process.env.VUE_APP_BRAND || 'anatin';
export const brandConfig: IBrandConfig = anatinConfig;
export const brandTheme: IBrandTheme = anatinTheme;

export const getLogoPath = (): string => {
  try {
    return require(`@/assets/${brandConfig.logo}`);
  } catch {
    return '';
  }
};
